import { LockboxImportActions } from './lockboxImport.actions';

export const lockboxImport = {
  namespaced: true,
  actions: {
    ...LockboxImportActions,
  },
};

export default lockboxImport;
